import { render, staticRenderFns } from "./VatExpenseReport.vue?vue&type=template&id=6faa8c19&scoped=true&"
import script from "./VatExpenseReport.vue?vue&type=script&lang=js&"
export * from "./VatExpenseReport.vue?vue&type=script&lang=js&"
import style0 from "./VatExpenseReport.vue?vue&type=style&index=0&id=6faa8c19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa8c19",
  null
  
)

export default component.exports